import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { Count as Text, Title } from '../SearchTitle.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShowResultTitle = ({
  searchTerm
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(PlayContainer, {
    width: "small",
    children: /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsxs(Title, {
        children: [`‘${searchTerm}‘ `, /*#__PURE__*/_jsx(Text, {
          children: t('search.inShows')
        })]
      })
    })
  });
};